import * as React from "react";
const SvgCleaner = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.212.598A2.75 2.75 0 0 1 9.55.25H18c.967 0 1.75.784 1.75 1.75v1.083a1.75 1.75 0 0 1-1.14 1.64l-1.798.668c.164.499.634.859 1.188.859a.75.75 0 0 1 0 1.5 2.751 2.751 0 0 1-2.595-1.837l-1.655.615v2.219l2.824 3.706a5.75 5.75 0 0 1 1.176 3.485V21A2.75 2.75 0 0 1 15 23.75H7A2.75 2.75 0 0 1 4.25 21v-5.062a5.75 5.75 0 0 1 1.176-3.485L8.25 8.747V6.742c-.912-.055-1.614-.38-2.107-.923-.52-.572-.723-1.297-.804-1.923-.14-1.078.518-1.986 1.327-2.437L8.212.598ZM9 5.25h3.659c.149 0 .296-.027.435-.078l4.993-1.855a.25.25 0 0 0 .163-.234V2a.25.25 0 0 0-.25-.25H9.55a1.25 1.25 0 0 0-.608.158l-1.545.861c-.42.234-.612.616-.571.934.063.482.2.858.428 1.108.204.225.562.439 1.278.439H9Zm.75 1.5v1.5h2.5v-1.5h-2.5Zm-.379 3L6.62 13.362a4.25 4.25 0 0 0-.869 2.576V21c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25v-1.25H13A2.75 2.75 0 0 1 10.25 17v-2A2.75 2.75 0 0 1 13 12.25h1.533l-1.904-2.5H9.37Zm6.273 4H13c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3.25v-2.312a4.25 4.25 0 0 0-.606-2.188Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgCleaner;
